import React, { useEffect, useState } from "react";
import AccountLayout from "./AccountLayout";
import { t } from "i18next";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import NoData from "../../component/NoData";

const WinnerBoard = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    status: "active",
    page: 1,
    limit: 100,
  });

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getTurnover, filter);
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
      }
    }
  };

  return (
    <AccountLayout title={"Winner Board"}>
      <ng-component className="ng-star-inserted">
        <router-outlet />
        <ng-component
          _nghost-serverapp-c2794537353
          className="ng-tns-c2794537353-13 ng-star-inserted"
        >
          <div
            _ngcontent-serverapp-c2794537353
            className="player-top ng-tns-c2794537353-13"
          >
            <div
              _ngcontent-serverapp-c2794537353
              className="tab-btn-section ng-tns-c2794537353-13"
            >
              <app-tab-button-nav
                _ngcontent-serverapp-c2794537353
                className="ng-tns-c2794537353-13"
                _nghost-serverapp-c1328719065
              >
                <div
                  _ngcontent-serverapp-c1328719065
                  className="tab-btn tab-btn-page"
                >
                  <div
                    _ngcontent-serverapp-c1328719065
                    className="line"
                    style={{
                      width: "calc(50%)",
                      "-webkit-transform": "translate(0%, 0px)",
                      "-ms-transform": "translate(0%, 0px)",
                      transform: "translate(0%, 0px)",
                    }}
                  />
                  <div
                    _ngcontent-serverapp-c1328719065
                    drctablinkactive="active"
                    className="btn ng-star-inserted active"
                    data-tab-current="current"
                  >
                    <div _ngcontent-serverapp-c1328719065 className="text">
                      Leader Board
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c1328719065
                    drctablinkactive="active"
                    className="btn ng-star-inserted"
                    data-tab-current
                  >
                    <div _ngcontent-serverapp-c1328719065 className="text">
                      First To Reach
                    </div>
                  </div>
                </div>
                <div
                  _ngcontent-serverapp-c1328719065
                  className="tab-btn-page-underline"
                />
              </app-tab-button-nav>
            </div>
          </div>

          <div
            _ngcontent-serverapp-c514414220
            className="tab-content tab-content-page"
          >
            <router-outlet _ngcontent-serverapp-c2497579489 />
            <mcd-leader-board
              _nghost-serverapp-c358032059
              className="ng-star-inserted"
            >
              <mcd-top-banner
                _ngcontent-serverapp-c358032059
                _nghost-serverapp-c309560012
                className="ng-star-inserted"
              >
                <div _ngcontent-serverapp-c309560012 className="top-banner">
                  <img
                    _ngcontent-serverapp-c309560012
                    alt="winner-board-banner"
                    src="/assets/NewImages/image_339510.webp"
                    loading="lazy"
                  />
                  <div
                    _ngcontent-serverapp-c309560012
                    className="top-banner__content"
                  >
                    <div
                      _ngcontent-serverapp-c309560012
                      className="top-banner__dropdown"
                    >
                      <div
                        _ngcontent-serverapp-c309560012
                        className="top-banner__dropdown-decoration"
                      >
                        <span
                          _ngcontent-serverapp-c309560012
                          className="top-banner__dropdown-decoration-icon"
                          style={{
                            "mask-image":
                              'url("/assets/NewImages/ribbon-left.webp?v=1776751585885")',
                          }}
                        />
                        <span
                          _ngcontent-serverapp-c309560012
                          className="top-banner__dropdown-decoration-icon"
                          style={{
                            "mask-image":
                              'url("/assets/NewImages/ribbon-right.webp?v=1776751585885")',
                          }}
                        />
                      </div>
                      <select
                        _ngcontent-serverapp-c309560012
                        className="top-banner__dropdown-list ng-untouched ng-pristine ng-valid"
                      >
                        <option
                          _ngcontent-serverapp-c309560012
                          className="top-banner__dropdown-list-option ng-star-inserted"
                          value={15}
                        >
                          Slots Leaderboard
                        </option>
                        <option
                          _ngcontent-serverapp-c309560012
                          className="top-banner__dropdown-list-option ng-star-inserted"
                          value={100006}
                        >
                          Crash Leaderboard
                        </option>
                        {/**/}
                      </select>
                    </div>
                    <div
                      _ngcontent-serverapp-c309560012
                      className="top-banner__footer"
                    >
                      <div
                        _ngcontent-serverapp-c309560012
                        className="top-banner__footer-date-range ng-star-inserted"
                      >
                        <span
                          _ngcontent-serverapp-c309560012
                          className="top-banner__footer-date-range-icon"
                          style={{
                            "mask-image":
                              'url("/assets/NewImages/icon-calendar.webp?v=1776751585885")',
                          }}
                        />
                        <span _ngcontent-serverapp-c309560012>
                          2026/02/09 - 2026/12/31
                        </span>
                      </div>
                      {/**/}
                      <div
                        _ngcontent-serverapp-c309560012
                        className="top-banner__footer-btn-block ng-star-inserted"
                      >
                        <button
                          _ngcontent-serverapp-c309560012
                          className="top-banner__footer-btn"
                        >
                          <span
                            _ngcontent-serverapp-c309560012
                            className="top-banner__footer-btn-icon"
                            style={{
                              "mask-image":
                                'url("/assets/NewImages/icon-reward.webp?v=1776751585885")',
                            }}
                          />
                        </button>
                        <button
                          _ngcontent-serverapp-c309560012
                          className="top-banner__footer-btn"
                        >
                          <span
                            _ngcontent-serverapp-c309560012
                            className="top-banner__footer-btn-icon"
                            style={{
                              "mask-image":
                                'url("/assets/NewImages/icon-history.webp?v=1776751585885")',
                            }}
                          />
                        </button>
                      </div>
                      {/**/}
                    </div>
                  </div>
                </div>
              </mcd-top-banner>
              <div
                _ngcontent-serverapp-c358032059
                className="leaderboard__title ng-star-inserted"
              >
                {" "}
                Leader Board{" "}
              </div>
              <div
                _ngcontent-serverapp-c358032059
                className="leaderboard__content ng-star-inserted"
              >
                <mcd-tab-btn
                  _ngcontent-serverapp-c358032059
                  _nghost-serverapp-c205137638
                >
                  <div
                    _ngcontent-serverapp-c205137638
                    className="tab-btn-block"
                  >
                    <div
                      _ngcontent-serverapp-c205137638
                      className="tab-btn tab-btn-page ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c205137638
                        className="btn ng-star-inserted active"
                      >
                        <div _ngcontent-serverapp-c205137638 className="text">
                          {" "}
                          Daily{" "}
                        </div>
                      </div>
                      <div
                        _ngcontent-serverapp-c205137638
                        className="btn ng-star-inserted"
                      >
                        <div _ngcontent-serverapp-c205137638 className="text">
                          {" "}
                          Weekly{" "}
                        </div>
                      </div>
                      {/**/}
                    </div>
                    {/**/}
                  </div>
                  <div _ngcontent-serverapp-c205137638 className="tab-content">
                    <div
                      _ngcontent-serverapp-c358032059
                      className="leaderboard__countdown-timer"
                    >
                      <mcd-countdown-timer
                        _ngcontent-serverapp-c358032059
                        _nghost-serverapp-c4276745577
                      >
                        <div
                          _ngcontent-serverapp-c4276745577
                          className="countdown-timer"
                        >
                          <div
                            _ngcontent-serverapp-c4276745577
                            className="countdown-timer__icon-block"
                          >
                            <div
                              _ngcontent-serverapp-c4276745577
                              className="countdown-timer__icon"
                              style={{
                                "mask-image":
                                  'url("/assets/NewImages/icon-time.webp?v=1776751585885")',
                              }}
                            />
                          </div>
                          <div
                            _ngcontent-serverapp-c4276745577
                            className="countdown-timer__text-block"
                          >
                            <div
                              _ngcontent-serverapp-c4276745577
                              className="countdown-timer__text-block-item"
                            >
                              <div
                                _ngcontent-serverapp-c4276745577
                                className="countdown-timer__text-block-item-value"
                              >
                                {" "}
                                0{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c4276745577
                                className="countdown-timer__text-block-item-label"
                              >
                                {" "}
                                day{" "}
                              </div>
                            </div>{" "}
                            :{" "}
                            <div
                              _ngcontent-serverapp-c4276745577
                              className="countdown-timer__text-block-item"
                            >
                              <div
                                _ngcontent-serverapp-c4276745577
                                className="countdown-timer__text-block-item-value"
                              >
                                {" "}
                                10{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c4276745577
                                className="countdown-timer__text-block-item-label"
                              >
                                {" "}
                                hr{" "}
                              </div>
                            </div>{" "}
                            :{" "}
                            <div
                              _ngcontent-serverapp-c4276745577
                              className="countdown-timer__text-block-item"
                            >
                              <div
                                _ngcontent-serverapp-c4276745577
                                className="countdown-timer__text-block-item-value"
                              >
                                {" "}
                                43{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c4276745577
                                className="countdown-timer__text-block-item-label"
                              >
                                {" "}
                                min{" "}
                              </div>
                            </div>{" "}
                            :{" "}
                            <div
                              _ngcontent-serverapp-c4276745577
                              className="countdown-timer__text-block-item"
                            >
                              <div
                                _ngcontent-serverapp-c4276745577
                                className="countdown-timer__text-block-item-value"
                              >
                                {" "}
                                9{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c4276745577
                                className="countdown-timer__text-block-item-label"
                              >
                                {" "}
                                sec{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      </mcd-countdown-timer>
                    </div>
                    <mcd-leader-board-list
                      _ngcontent-serverapp-c358032059
                      _nghost-serverapp-c599568069
                    >
                      <div
                        _ngcontent-serverapp-c599568069
                        className="leader-board-list"
                      >
                        <div
                          _ngcontent-serverapp-c599568069
                          className="leader-board-list__t3 ng-star-inserted"
                        >
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__t3-item ng-star-inserted"
                            style={{
                              "background-image":
                                'url("/assets/NewImages/bg-silver.webp?v=1776751585885")',
                            }}
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__t3-item-crown"
                              style={{
                                "background-image":
                                  'url("/assets/NewImages/crown-silver.webp?v=1776751585885")',
                              }}
                            />
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__t3-item-icon"
                              style={{
                                "background-image":
                                  'url("/assets/NewImages/JILI-SLOT-138.webp?v=1751537714291")',
                              }}
                            />
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__t3-item-content"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__t3-item-game-name"
                              >
                                {" "}
                                Fortune Gems 500{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__t3-item-user-name"
                              >
                                {" "}
                                pu***66 {/**/}
                                {/**/}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__t3-item-amount"
                              >
                                {" "}
                                ৳ 49,500 {/**/}
                                {/**/}
                                {/**/}
                                {/**/}
                                {/**/}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__t3-item-prize"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__t3-item-prize-icon-bg"
                                >
                                  <div
                                    _ngcontent-serverapp-c599568069
                                    className="leader-board-list__t3-item-prize-icon"
                                    style={{
                                      "mask-image":
                                        'url("/assets/NewImages/icon-reward.webp?v=1776751585885")',
                                    }}
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__t3-item-prize-amount"
                                >
                                  {" "}
                                  2,000 {/**/}
                                  {/**/}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__t3-item-rank"
                            >
                              {" "}
                              2{" "}
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__t3-item ng-star-inserted"
                            style={{
                              "background-image":
                                'url("/assets/NewImages/bg-gold.webp?v=1776751585885")',
                            }}
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__t3-item-crown"
                              style={{
                                "background-image":
                                  'url("/assets/NewImages/crown-gold.webp?v=1776751585885")',
                              }}
                            />
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__t3-item-icon"
                              style={{
                                "background-image":
                                  'url("/assets/NewImages/JILI-SLOT-027.webp?v=1751418030805")',
                              }}
                            />
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__t3-item-content"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__t3-item-game-name"
                              >
                                {" "}
                                Super Ace{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__t3-item-user-name"
                              >
                                {" "}
                                md***60 {/**/}
                                {/**/}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__t3-item-amount"
                              >
                                {" "}
                                ৳ 51,500 {/**/}
                                {/**/}
                                {/**/}
                                {/**/}
                                {/**/}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__t3-item-prize"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__t3-item-prize-icon-bg"
                                >
                                  <div
                                    _ngcontent-serverapp-c599568069
                                    className="leader-board-list__t3-item-prize-icon"
                                    style={{
                                      "mask-image":
                                        'url("/assets/NewImages/icon-reward.webp?v=1776751585885")',
                                    }}
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__t3-item-prize-amount"
                                >
                                  {" "}
                                  3,000 {/**/}
                                  {/**/}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__t3-item-rank"
                            >
                              {" "}
                              1{" "}
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__t3-item ng-star-inserted"
                            style={{
                              "background-image":
                                'url("/assets/NewImages/bg-bronze.webp?v=1776751585885")',
                            }}
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__t3-item-crown"
                              style={{
                                "background-image":
                                  'url("/assets/NewImages/crown-bronze.webp?v=1776751585885")',
                              }}
                            />
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__t3-item-icon"
                              style={{
                                "background-image":
                                  'url("/assets/NewImages/JILI-SLOT-193.webp?v=1773707965342")',
                              }}
                            />
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__t3-item-content"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__t3-item-game-name"
                              >
                                {" "}
                                Fortune Garuda 500{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__t3-item-user-name"
                              >
                                {" "}
                                sh***26 {/**/}
                                {/**/}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__t3-item-amount"
                              >
                                {" "}
                                ৳ 42,100 {/**/}
                                {/**/}
                                {/**/}
                                {/**/}
                                {/**/}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__t3-item-prize"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__t3-item-prize-icon-bg"
                                >
                                  <div
                                    _ngcontent-serverapp-c599568069
                                    className="leader-board-list__t3-item-prize-icon"
                                    style={{
                                      "mask-image":
                                        'url("/assets/NewImages/icon-reward.webp?v=1776751585885")',
                                    }}
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__t3-item-prize-amount"
                                >
                                  {" "}
                                  1,500 {/**/}
                                  {/**/}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__t3-item-rank"
                            >
                              {" "}
                              3{" "}
                            </div>
                          </div>
                          {/**/}
                        </div>
                        <div
                          _ngcontent-serverapp-c599568069
                          className="leader-board-list__rk leader-board-list__rk--margin-bottom ng-star-inserted"
                        >
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  4{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/FC-SLOT-049.webp?v=1770273832253"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  SUPER ELEMENTS{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                al***80{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 41,760 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  5{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/PP-SLOT-443.webp?v=1751418030744"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  Sugar Rush 1000{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                su***ni{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 40,627 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  6{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/JILI-SLOT-050.webp?v=1751418030805"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  Medusa{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                01***18{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 40,000 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  7{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/JILI-SLOT-204.webp?v=1775649232898"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  Fortune Gems Legend{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                al***44{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 29,996 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  8{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/JILI-SLOT-163.webp?v=1766711384861"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  Clover Coins 3x3{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                md***75{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 29,990 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  9{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/PP-SLOT-598.Fortune Ace Super Scatter.webp?v=1768297807931"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  Fortune Ace Super Scatter{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                fa***00{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 28,725 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  10{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/FC-SLOT-033.webp?v=1751418030798"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  SUPER ELEMENTS{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                01***54{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 27,590 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  11{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/JILI-SLOT-102.webp?v=1755510499511"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  Super Ace Deluxe{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                01***an{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 26,426 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  12{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/JILI-SLOT-027.webp?v=1751418030805"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  Super Ace{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                sh***at{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 25,060 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  13{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/JILI-SLOT-136.circus-joker-4096.webp?v=1764310876561"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  Circus Joker 4096{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                mi***il{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 24,840 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  14{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/JILI-SLOT-138.webp?v=1751537714291"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  Fortune Gems 500{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                he***89{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 23,700 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  15{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/JILI-SLOT-138.webp?v=1751537714291"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  Fortune Gems 500{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                on***01{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 23,600 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  16{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/JILI-SLOT-102.webp?v=1755510499511"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  Super Ace Deluxe{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                so***54{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 23,560 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  17{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/JILI-SLOT-166.webp?v=1770862519057"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  20 Blazing Clover{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                di***70{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 23,000 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  18{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/JILI-SLOT-188.webp?v=1767777819635"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  10 Sparkling Crown 2{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                01***16{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 22,500 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  19{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/JDB-SLOT-127.magic-ace-wild-lock.webp?v=1776138413892"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  Magic Ace WILD LOCK{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                mk***47{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 21,700 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__rk-item ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-info-wrapper"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-info"
                              >
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-rank-number"
                                >
                                  {" "}
                                  20{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-icon"
                                >
                                  <img
                                    _ngcontent-serverapp-c599568069
                                    alt="game-icon"
                                    loading="lazy"
                                    src="/assets/NewImages/JILI-SLOT-102.webp?v=1755510499511"
                                  />
                                </div>
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__rk-game-name"
                                >
                                  {" "}
                                  Super Ace Deluxe{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__rk-user-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-name"
                              >
                                {" "}
                                01***83{" "}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__rk-user-amount"
                              >
                                {" "}
                                ৳ 21,620 {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          {/**/}
                        </div>
                        <div
                          _ngcontent-serverapp-c599568069
                          className="leader-board-list__usr ng-star-inserted"
                        >
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__usr-info-wrapper"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__usr-info"
                            >
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__usr-rank-number"
                              >
                                {" "}
                                100+ {/**/}
                              </div>
                              <div
                                _ngcontent-serverapp-c599568069
                                className="leader-board-list__usr-title"
                              >
                                {" "}
                                My Ranking{" "}
                                <div
                                  _ngcontent-serverapp-c599568069
                                  className="leader-board-list__usr-reward"
                                >
                                  <div
                                    _ngcontent-serverapp-c599568069
                                    className="leader-board-list__usr-reward-icon-bg"
                                  >
                                    <div
                                      _ngcontent-serverapp-c599568069
                                      className="leader-board-list__usr-reward-icon"
                                      style={{
                                        "mask-image":
                                          'url("/assets/NewImages/icon-reward.webp?v=1776751585885")',
                                      }}
                                    />
                                  </div>
                                  <div
                                    _ngcontent-serverapp-c599568069
                                    className="leader-board-list__usr-reward-no-prize ng-star-inserted"
                                  >
                                    {" "}
                                    No Prize{" "}
                                  </div>
                                  {/**/}
                                  {/**/}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c599568069
                            className="leader-board-list__usr-next-info"
                          >
                            <div
                              _ngcontent-serverapp-c599568069
                              className="leader-board-list__usr-next-title-hint ng-star-inserted"
                            >
                              {" "}
                              You can do it next time!{" "}
                            </div>
                            {/**/}
                            {/**/}
                            {/**/}
                            {/**/}
                          </div>
                        </div>
                        {/**/}
                        {/**/}
                        <div
                          _ngcontent-serverapp-c599568069
                          id="isScrolledDetector"
                          className="leader-board-list__intersection-detector ng-star-inserted"
                        />
                        <div
                          _ngcontent-serverapp-c599568069
                          id="isAllInViewportDetector"
                          className="ng-star-inserted"
                        />
                        {/**/}
                        {/**/}
                      </div>
                    </mcd-leader-board-list>
                  </div>
                </mcd-tab-btn>
              </div>
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
            </mcd-leader-board>
            {/**/}
          </div>
        </ng-component>
      </ng-component>
    </AccountLayout>
  );
};

export default WinnerBoard;
